import React, { useEffect, useState, useRef } from "react";
import Pulse from "../Loader/Pulse";
import {
  ArrowLeft,
  ArrowRight2,
  Cross,
  OrderBook,
} from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import MFSearch from "./MFSearch";
import ServerRequest from "../../exports/ServerRequest";
import { GetCookie } from "../../exports/CookieManagement";
import SwiftModal from "../CustomComponents/SwiftModal/SwiftModal";
import CustomInputFile from "../CustomComponents/CustomInputFile/CustomInputFile";
import {
  convertNumberToWords,
  formatSchemeName,
  isEmpty,
  numberFormat,
  priceFormat,
} from "../../exports/UtilFunctions";
import CustomIconButton from "../Body/CustomChartComponents/CustomIconButton/CustomIconButton";
import { getDeviceSize } from "../../exports/InteractiveUtils";
import CustomSelect from "../Body/CustomChartComponents/CustomSelect/CustomSelect";
import MFChartContainer from "./MFChartContainer.js";
import MFPerformanceMetrics from "./MFPerformanceMetrics.jsx";
import "../../css/MFManagement/MFManagement.css";
import "../../css/Fade.css";
import showChartIcon from "../../assets/icons/show_chart_24.svg";
import chartDelete from "../../assets/icons/chart-delete.svg";

const DEVICE_SIZE = getDeviceSize();

const Watchlist = () => {
  const [loading, setLoading] = useState(false);
  const [watchlist, setWatchlist] = useState([]);
  const [change, setChange] = useState(1);
  const [latestNavLoading, setLatestNavLoading] = useState(true);
  const [popup, setPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [finalpopup, setFinalpopup] = useState(false);
  const [error, setError] = useState("null");
  const [popupLoading, setPopupLoading] = useState(false);
  const [detailsPopup, setDetailsPopup] = useState(false);
  const [detailsData, setDetailsData] = useState({});
  const [benchmarkData, setBenchmarkData] = useState([]);
  const [selectedBenchmarkObj, setSelectedBenchmarkObj] = useState(null);
  const [selectedBenchmark, setSelectedBenchmark] = useState("Nifty_50");
  const [latestNavDetails, setLatestNavDetails] = useState({});
  const [navPerformance, setNavPerformance] = useState({});
  const [benchmarkPerformance, setBenchmarkPerformance] = useState({});
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [chartLoading, setChartLoading] = useState(true);
  const [metricsLoading, setMetricsLoading] = useState(true);
  const [opacityMsg, setOpacityMsg] = useState(true);
  const [chartOpacityMsg, setChartOpacityMsg] = useState(true);
  const [loadingMsg, setLoadingMsg] = useState("Fetching your watchlist");
  const [chartLoadingMsg, setChartLoadingMsg] = useState("Loading chart data");

  const isSmallDevice = DEVICE_SIZE === "S";

  useEffect(() => {
    setLoading(true);

    fetchWatchListDetails();
  }, [change]);

  const isDefined = (...flags) => flags.every((v) => v !== undefined);

  useEffect(() => {
    if (!isDefined(chartLoading, metricsLoading, latestNavLoading)) return;

    const allLoaded = !chartLoading && !metricsLoading && !latestNavLoading;
    setDetailsLoading(!allLoaded);
  }, [chartLoading, metricsLoading, latestNavLoading]);

  useEffect(() => {
    const loadingMessageInterval = setInterval(() => {
      setLoadingMsg((prev) =>
        prev === "Fetching your watchlist"
          ? "It may take some time"
          : "Fetching your watchlist",
      );
    }, 3000);

    const opacityInterval = setInterval(() => {
      setOpacityMsg((prev) => !prev);
    }, 1500);

    return () => {
      clearInterval(loadingMessageInterval);
      clearInterval(opacityInterval);
    };
  }, []);

  useEffect(() => {
    if (!detailsLoading) return;

    const chartLoadingMessageInterval = setInterval(() => {
      setChartLoadingMsg((prev) =>
        prev === "Loading chart data"
          ? "It may take some time"
          : "Loading chart data",
      );
    }, 3000);

    const chartOpacityInterval = setInterval(() => {
      setChartOpacityMsg((prev) => !prev);
    }, 1500);

    return () => {
      clearInterval(chartLoadingMessageInterval);
      clearInterval(chartOpacityInterval);
    }; // cleanup
  }, []);

  const prevISINRef = useRef();

  useEffect(() => {
    if (!detailsData?.ISIN || prevISINRef.current === detailsData.ISIN) return;

    prevISINRef.current = detailsData.ISIN;
    getLatestNav();
    getNavPerformanceMetric();
  }, [detailsData]);

  useEffect(() => {
    if (!selectedBenchmark) return;
    getBenchmarkPerformanceMetric();
  }, [selectedBenchmark]);

  const account_token = GetCookie("token");

  const fetchWatchListDetails = async () => {
    try {
      const response = await ServerRequest({
        url: `/mf/watchlistdetails?token?=${account_token}`,
        method: "get",
      });

      // Update state with received data
      const data = response.data || [];

      setWatchlist(data);
    } catch (error) {
      console.error("Failed to fetch watchlist", error);
      setWatchlist([]);
    } finally {
      setLoading(false);
    }
  };

  // get current nav and change
  const getLatestNav = async () => {
    if (!detailsData.ISIN) return;
    setLatestNavLoading(true);
    try {
      const response = await ServerRequest({
        url: `/mf/latestnav/${detailsData.ISIN}`,
        method: "get",
      });
      if (!response.error && response.result) {
        setLatestNavDetails(response.result);
      } else {
        console.warn("NAV fetch failed", response.message);
      }
    } catch (error) {
      console.error("Error fetching latest NAV:", error);
    } finally {
      setLatestNavLoading(false);
    }
  };

  // get nav performact metrics

  const getNavPerformanceMetric = async () => {
    if (!detailsData.ISIN) return;

    try {
      const response = await ServerRequest({
        url: `/mf/navdata/get/${detailsData.ISIN}`,
        method: "get",
      });
      if (!response.error && response) {
        setNavPerformance(response.data.returnStats);
      } else {
        console.warn("NAV Performance fetch failed", response.message);
      }
    } catch (error) {
      console.error("Error fetching  NAV Performance:", error);
    }
  };

  // get BenchMark performact metrics

  const getBenchmarkPerformanceMetric = async () => {
    if (!selectedBenchmark) return;

    try {
      const response = await ServerRequest({
        url: `/mf/benchmark/get/${selectedBenchmark}`,
        method: "get",
      });
      if (!response.error && response.data?.returnStats) {
        setBenchmarkPerformance(response.data.returnStats);
      } else {
        console.warn("BenchMark Performance fetch failed", response.message);
      }
    } catch (error) {
      console.error("Error fetching BenchMark Performance:", error);
    }
  };

  const handleClick = async (symbol) => {
    const response = await ServerRequest({
      url: `/mf/add?token=${account_token}`,
      data: symbol,
      method: "post",
      //  signal: signal,
    });
    setChange(Math.random());

    // if (response.server_error) {
    //   navigate("/404", { state: { errorMessage: response.message } });
    // }
  };

  const BuyHandler = async (d) => {
    setPopup(true);
    let data = d;
    data.type = "Buy";
    setPopupData(data);
  };

  const DeleteHandler = async (isin, scheme_code, unique_code) => {
    setLoading(true);
    const response = await ServerRequest({
      url: `/mf/delete?token=${account_token}`,
      method: "delete",
      data: { isin: isin, unique_code: unique_code, scheme_code: scheme_code },
      //  signal: signal,
    });
    setLoading(false);
    setChange(Math.random());
  };
  const handlerSubmit = async () => {
    setError("null");

    const amount = parseFloat(popupData.amount);
    const minPurchaseAmount = parseFloat(popupData.Minimum_Purchase_Amount);

    if (isEmpty(popupData.amount)) {
      setError(`Cannot be less than ${minPurchaseAmount}`);
      return;
    }

    if (amount < minPurchaseAmount) {
      setError(`Cannot be less than ${minPurchaseAmount}`);
      return;
    }
    setPopupLoading(true);

    popupData.status = "UTR Pending";

    const response = await ServerRequest({
      url: `/mf/orderbook?token=${account_token}`,
      data: popupData,
      method: "post",
      //  signal: signal,
    });
    setTimeout(() => {
      setPopup(false);
      setError("null");
      setPopupData({});
      setFinalpopup(true);
      setPopupLoading(false);
    }, 3000);
  };

  const handleDetailsPopup = (items) => {
    setDetailsPopup(true);
    setDetailsData(items);
  };

  useEffect(() => {
    const fetchBenchmarkData = async () => {
      // setLoading(true);
      try {
        const res = await ServerRequest({
          url: `/mf/benchmark/get?token=${account_token}`,
          method: "get",
        });

        setBenchmarkData(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        // setLoading(false);
      }
    };

    fetchBenchmarkData();
  }, [account_token]);

  return (
    <div className="mf-wrapper">
      {loading ? (
        <div className="app__login__screen">
          <div className="app__login__process">
            <Pulse />
            {/* <p className={opacityMsg ? "fadeIn" : "fadeOut"}>{loadingMsg}</p> */}
          </div>
        </div>
      ) : (
        <>
          <MFSearch handleSelect={handleClick} />
          <div className="mf-container mf-watchlist-container">
            {watchlist.length === 0 ? (
              <div className="mf-empty">
                <OrderBook size={40} color={COLOR_VARS["SWIFT_COLOR4"]} />
                <div>
                  <p>No Watchlist found</p>
                  <span>Looks like you haven't added any Mutual Funds yet</span>
                </div>
              </div>
            ) : DEVICE_SIZE === "S" ? (
              watchlist.map((h, index) => (
                <WatchListCard
                  key={index}
                  data={h}
                  BuyHandler={BuyHandler}
                  DeleteHandler={DeleteHandler}
                  handleDetailsPopup={handleDetailsPopup}
                />
              ))
            ) : (
              <table>
                <thead>
                  <tr>
                    <td className="scheme-name">Scheme Name</td>
                    <td className="">ISIN</td>
                    <td className="category">Category</td>
                    <td className="">Purchase Min.</td>
                    <td className="">Add. Pur. Min.</td>
                    <td className="">Redemp. Min. Amt.</td>
                    <td className="">SIP Min. Installment </td>
                    <td className="">NAV</td>
                    <td className="">Change %</td>
                    <td className="hover-td"></td>
                  </tr>
                </thead>
                <tbody>
                  {watchlist.map((h, index) => {
                    return (
                      <tr key={index} className="yes_hover">
                        <td title={h.SCHEME_NAME} className="body-scheme-name">
                          {h["SCHEME_NAME"]}
                        </td>
                        <td title={h["ISIN"]}>{h["ISIN"]}</td>
                        <td className="body-category">{h["category"]}</td>
                        <td>{priceFormat(h["NEW_PURCHASE_MIN_AMOUNT"])}</td>
                        <td>
                          {priceFormat(h["ADDITIONAL_PURCHASE_MIN_AMOUNT"])}
                        </td>
                        <td>{priceFormat(h["REDEMPTION_MIN_AMOUNT"])}</td>

                        <td>
                          {priceFormat(h["SIP_MINIMUM_INSTALLMENT_AMOUNT"])}
                        </td>
                        <td>{priceFormat(h["nav"])}</td>
                        <td className={h.change >= 0 ? "positive" : "negative"}>
                          {numberFormat(h.change)}%
                        </td>
                        <td>
                          <div className="hover-container">
                            {/* <div
                                    className="hover-btn"
                                    onClick={() => {
                                      BuyHandler(h);
                                    }}
                                  >
                                    Buy
                                  </div> */}
                            <div
                              className="hover-btn"
                              onClick={() => handleDetailsPopup(h)}
                            >
                              {/* <img src={showChartIcon} alt="hoverbutton" /> */}
                              Chart
                            </div>
                            <div
                              className="hover-btn"
                              onClick={() =>
                                DeleteHandler(
                                  h["ISIN"],
                                  h["SCHEME_CODE"],
                                  h["unique_code"],
                                )
                              }
                            >
                              {/* <img src={chartDelete} alt="hoverbutton" /> */}
                              Delete
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}

      {popup && (
        <SwiftModal
          closeModal={() => {
            setPopup(false);
            setError("null");
            setPopupData({});
            setPopupLoading(false);
          }}
          top="2%"
        >
          <div className="swift-mf-popup">
            {popupLoading === true ? (
              <div className="swift-mf-popup-loader">
                <Pulse />
{/* <p>Order in progress</p> */}
              </div>
            ) : (
              <>
                <div className="swift-mf-popup-header">
                  <div
                    className={`swift-mf-popup-btn ${popupData.type.toLowerCase()}`}
                  >
                    {popupData.type}
                  </div>
                  <div
                    className="swift-account-svg"
                    onClick={() => {
                      setPopup(false);
                      setError("null");
                      setPopupData({});
                      setPopupLoading(false);
                    }}
                  >
                    <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
                  </div>
                </div>
                <div className="swift-mf-popup-body">
                  <p className="swift-mf-popup-name">{popupData.SCHEME_NAME}</p>
                  <p className="swift-mf-popup-isin">
                    {popupData.ISIN} | {popupData.SCHEME_TYPE}
                  </p>
                  <div className="swift-mf-popup-price">
                    <span>{numberFormat(popupData.nav)}</span>
                    <span
                      className={popupData.change > 0 ? "positive" : "negative"}
                    >
                      {popupData.change}%
                    </span>
                  </div>
                  {/* <div style={{ paddingTop: "15px" }}> */}
                  <CustomInputFile
                    label=""
                    name="amount"
                    type="decimal"
                    maxlength="13"
                    className="swift-mf-bonds-inputs"
                    DivClassName="swift-mf-bonds-inputs-div"
                    value={popupData["amount"]}
                    onchange={(name, value) => {
                      if (value.trim() === "") value = "";
                      setPopupData((prevValues) => ({
                        ...prevValues,
                        [name]: value,
                        amountWords: convertNumberToWords(value),
                      }));
                    }}
                    error={error}
                    placeholder="Purchase Amount"
                  />
                  {/* </div> */}

                  <div
                    className="swift-mf-popup-words"
                    style={{ paddingBottom: "13px" }}
                  >
                    <p>In words</p>
                    <p>
                      {popupData.amountWords ? popupData.amountWords : "--"}
                    </p>
                  </div>

                  <div
                    className="swift-mf-popup-words"
                    style={{ paddingBottom: "23px" }}
                  >
                    <p>Approximate Units</p>
                    <p>
                      {(popupData.amount >=
                        parseFloat(popupData.Minimum_Purchase_Amount) &&
                        (
                          Math.floor((popupData.amount / popupData.nav) * 100) /
                          100
                        )
                          .toFixed(2)
                          .replace(/\.0+$/, "")) ||
                        0}
                    </p>
                  </div>
                  <div className="swift-mf-popup-text">
                    Post placement of the order, kindly make sure that you carry
                    out the bank transfer and go to the transaction section to
                    input the UTR number of the bank transfer. Failure to do
                    that will result in a transaction rejection.
                  </div>
                </div>
                <div className="swift-mf-popup-submit-btn">
                  <CustomIconButton
                    title="Submit"
                    icon={
                      {/* <ArrowRight2 size={20} color={COLOR_VARS.SWIFT_COLOR1} /> */}
                    }
                    onClick={handlerSubmit}
                  />
                </div>
              </>
            )}
          </div>
        </SwiftModal>
      )}
      {finalpopup && (
        <SwiftModal closeModal={() => setFinalpopup(false)} top="2%">
          <div className="swift-mf-popup swift-mf-final-popup">
            <div className="swift-mf-popup-body swift-mf-final-popup-body">
              <p>Order placed successfully!</p>
              <p>
                You will receive an email with details of bank account where you
                need to pay for the order via NEFT/ RTGS..
              </p>
              <p>You have 12 hours to complete the transaction.</p>
            </div>
            <div className="swift-mf-popup-submit-btn">
              <CustomIconButton
                title="Close"
                icon={null}
                onClick={() => setFinalpopup(false)}
              />
            </div>
          </div>
        </SwiftModal>
      )}
      {detailsPopup && (
        <SwiftModal
          closeModal={() => {
            setDetailsPopup(false);
            setDetailsData({});
          }}
          top="2%"
        >
          <div className="swift-mf-details-popup swift-mf-popup ">
            {detailsLoading && (
              <div className="app__login__screen">
                <div className="app__login__process">
                  <Pulse />
                  {/* <p className={chartOpacityMsg ? "fadeIn" : "fadeOut"}>
                    {chartLoadingMsg}
                  </p> */}
                </div>
              </div>
            )}
            <>
              {!detailsLoading && (
                <div className="swift-mf-popup-header">
                  <div
                    className="swift-account-svg"
                    onClick={() => {
                      setDetailsPopup(false);
                      setDetailsData({});
                    }}
                  >
                    {isSmallDevice ? (
                      <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "end",
                    }}
                  >
                    <p className="swift-mf-popup-name">
                      {detailsData.SCHEME_NAME}
                    </p>
                    {isSmallDevice ? (
                      ""
                    ) : (
                      <div
                        className="swift-account-svg swift-mf-popup-close-btn"
                        onClick={() => {
                          setDetailsPopup(false);
                        }}
                      >
                        <Cross size={30} color={COLOR_VARS["SWIFT_COLOR4"]} />
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="swift-mf-details-popup-body swift-mf-details-popup-body-flex">
                <>
                  {!detailsLoading && (
                    <div
                      className="swift-mf-details-body-head"
                      style={{ zIndex: "1000" }}
                    >
                      <div className="swift-mf-head-left">
                        {latestNavLoading ? (
                          <div style={{ paddingLeft: "40px" }}>
                            <Pulse />
                          </div>
                        ) : (
                          <div className="">
                            <p className="swift-mf-popup-isin">
                              {detailsData.ISIN}
                            </p>

                            <div
                              style={{
                                display: "flex",
                                gap: "12px",
                                width: "100%",
                              }}
                            >
                              <p className="swift-mf-popup-nav">
                                {latestNavDetails.latest_nav}
                              </p>
                              <p
                                className={`swift-mf-popup-change ${latestNavDetails.navChange >= 0 ? "positive" : "negative"}`}
                              >
                                {latestNavDetails.navChange}%
                              </p>
                              <p className="swift-mf-popup-date">
                                {" "}
                                {`as of ${latestNavDetails.latest_nav_date}`}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>

                      <CustomSelect
                        defaultIndex={Math.max(
                          0,
                          benchmarkData.findIndex(
                            (b) =>
                              b.benchmark_common_name ===
                              selectedBenchmarkObj?.benchmark_common_name,
                          ),
                        )}
                        options={benchmarkData.map(
                          (b) => b.benchmark_common_name,
                        )}
                        width={240}
                        height={40}
                        placeholder="Select Benchmark"
                        onTypeChange={(value) => {
                          const selected = benchmarkData.find(
                            (b) => b.benchmark_common_name === value,
                          );
                          setSelectedBenchmarkObj(selected);
                          setSelectedBenchmark(
                            selected?.benchmark_database_name,
                          );
                        }}
                      />
                    </div>
                  )}
                  <div className="swift-mf-chart-section full-chart-wrapper">
                    <div className="chart-section-inner">
                      {isSmallDevice == "S" ? (
                        <MFChartContainer
                          selectedData={detailsData.ISIN}
                          chartHeight={200}
                          chartWidth={1040}
                          selectedBenchmark={selectedBenchmark}
                          onChangeLoading={setChartLoading}
                          showContent={!detailsLoading}
                          chartType={"watchlist"}
                        />
                      ) : (
                        <MFChartContainer
                          selectedData={detailsData.ISIN}
                          chartHeight={300}
                          chartWidth={1040}
                          selectedBenchmark={selectedBenchmark}
                          onChangeLoading={setChartLoading}
                          showContent={!detailsLoading}
                          chartType={"watchlist"}
                        />
                      )}
                    </div>
                  </div>
                  <div className="swift-mf-chart-performancemetric">
                    <MFPerformanceMetrics
                      navPerformance={navPerformance}
                      benchmarkPerformance={benchmarkPerformance}
                      onChangeLoading={setMetricsLoading}
                      showContent={!detailsLoading}
                    />
                  </div>
                </>
              </div>
            </>
          </div>
        </SwiftModal>
      )}
    </div>
  );
};

function WatchListCard({
  data,
  BuyHandler,
  DeleteHandler,
  handleDetailsPopup,
}) {
  const [active, setActive] = useState(false);
  const cardRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        setActive(false);
      }
    }

    if (active) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [active]);

  const {
    ISIN,
    Scheme_Code,
    Unique_No,
    SCHEME_NAME,
    nav,
    change,
    NEW_PURCHASE_MIN_AMOUNT,
    ADDITIONAL_PURCHASE_MIN_AMOUNT,
    REDEMPTION_MIN_AMOUNT,
    category,
    SIP_MINIMUM_INSTALLMENT_AMOUNT,
  } = data;

  return (
    <>
      {/* <div className="mf-watchlist-card" onClick={() => setActive(true)} ref={cardRef}>
        <div className="mfwc-info">
          <div className="isin-price">
            <p className="isin-type">{ISIN}</p>
            <p className="price-change">
              {nav}&nbsp;&nbsp;
              <span className={change >= 0 ? "positive" : "negative"}>
                ({numberFormat(change)}%)
              </span>
            </p>
          </div>
          <p className="name">{SCHEME_NAME}</p>
          <p className="category">{category}</p>
        </div>
        <div className="mfwc-config">
          <div className="mfwc-config-row">
            <p>
              Purchase Min.<span>{numberFormat(NEW_PURCHASE_MIN_AMOUNT)}</span>
            </p>
            <p>
              Add. Purchase. Min
              <span>{numberFormat(ADDITIONAL_PURCHASE_MIN_AMOUNT)}</span>
            </p>
          </div>
          <div className="mfwc-config-row">
            <p>
              Redemption Min. Amt.<span>{REDEMPTION_MIN_AMOUNT}</span>
            </p>
            <p>
              SIP Min. Installment
              <span>{SIP_MINIMUM_INSTALLMENT_AMOUNT}</span>
            </p>
          </div>
        </div>
        {active ? (
          <div className="sp__hover__options" ref={cardRef}>
            <div
              className="sp__hover__buttons"
              onClick={() => handleDetailsPopup(data)}
            >
              <img src={showChartIcon} alt="hoverbutton" width={"20px"} height={"15px"} />
              Chart
            </div>
            <div
              className="sp__hover__buttons"
              onClick={() => DeleteHandler(ISIN, Scheme_Code, Unique_No)}
            >
              <img src={chartDelete} alt="hoverbutton" width={"20px"} height={"15px"} />
              Delete
            </div>
          </div>
        ) : ("")}
      </div> */}

      <div
        className="mf-watchlist-card"
        onClick={() => setActive(true)}
        ref={cardRef}
      >
        {/* <div className="mfwc-info">
          <div className="isin-price">
            <p className="isin-type">{ISIN}</p>
            <p className="price-change"></p>
          </div>
        </div> */}
        <div className="mfwc-config">
          <div className="mfwc-config-row">
            <p></p>
          </div>
          <div className="mfwc-config-row">
            <p className="mfwc-title-row">
              <p className="name">{formatSchemeName(SCHEME_NAME, 30)}</p>
              <p className="category">{category}</p>
            </p>
            <p className="value">
              <span style={{fontSize:"12px"}}>
                {nav}&nbsp;
                <span className={change >= 0 ? "positive" : "negative"}>
                  ({numberFormat(change)}%)
                </span>
              </span>
              <p className="category">{ISIN}</p>
            </p>
          </div>

          <div className="mfwc-config-row">
            <p>
              Purchase Min.&nbsp;-&nbsp;
              <span>{numberFormat(NEW_PURCHASE_MIN_AMOUNT)}</span>
            </p>
            <p>
              Add. Purchase. Min&nbsp;-&nbsp;
              <span>{numberFormat(ADDITIONAL_PURCHASE_MIN_AMOUNT)}</span>
            </p>
          </div>
          <div className="mfwc-config-row">
            <p>
              Redemption Min. Amt.&nbsp;-&nbsp;
              <span>{REDEMPTION_MIN_AMOUNT}</span>
            </p>
            <p>
              SIP Min. Installment&nbsp;-&nbsp;
              <span>{SIP_MINIMUM_INSTALLMENT_AMOUNT}</span>
            </p>
          </div>
        </div>
        {active ? (
          <div className="sp__hover__options" ref={cardRef}>
            <div
              className="sp__hover__buttons"
              onClick={() => handleDetailsPopup(data)}
            >
              {/* <img
                src={showChartIcon}
                alt="hoverbutton"
                width={"20px"}
                height={"15px"}
              /> */}
              Chart
            </div>
            <div
              className="sp__hover__buttons"
              onClick={() => DeleteHandler(ISIN, Scheme_Code, Unique_No)}
            >
              {/* <img
                src={chartDelete}
                alt="hoverbutton"
                width={"20px"}
                height={"15px"}
              /> */}
              Delete
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default Watchlist;
